/* eslint-disable @typescript-eslint/no-explicit-any */

var TAB_THEME_KEY = 'tabs';

export { TAB_THEME_KEY };
//# sourceMappingURL=types.esm.js.map
